import * as React from 'react';
import { DataGrid, GridColDef } from '@mui/x-data-grid';
import { Transaction } from 'interfaces/Transaction.interface';
import Loader from 'components/atoms/loader';

const columns: GridColDef[] = [
  { field: 'id', headerName: 'ID', width: 70 },
  { field: 'hash', headerName: 'Hash', width: 130 },
  { field: 'walletAddress', headerName: 'From Wallet', width: 130 },
  {
    field: 'amount',
    headerName: 'Amount',
    width: 90,
  },
  {
    field: 'amountUsd',
    headerName: 'USD rate',
    sortable: false,
    width: 160,
    renderCell: params => {
      return <span>{params.value || 'N/A'}</span>;
    },
  },

  {
    field: 'receipt',
    headerName: 'Transaction Reciept',
    sortable: false,
    width: 160,
    renderCell: params => (
      <a target="_blank" rel="noreferrer" href={params.value}>
        {params.value}
      </a>
    ),
  },
];

interface ITransactionTableProps {
  transactions: Transaction[];
  loading: boolean;
}

const TransactionTable = ({
  transactions,
  loading,
}: ITransactionTableProps) => {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: 400,
        width: '100%',
        backgroundColor: loading ? 'transparent' : 'white',
      }}
    >
      {loading ? (
        <Loader />
      ) : (
        <DataGrid
          rows={transactions.map(transaction => {
            return {
              ...transaction,
              walletAddress: transaction.from.walletAddress,
              receipt: `https://goerli.etherscan.io/tx/${transaction.hash}`,
              USD: transaction.amount,
            };
          })}
          columns={columns}
          pageSize={5}
          rowsPerPageOptions={[5]}
        />
      )}
    </div>
  );
};

export default TransactionTable;
